import Image from 'next/image'

import { Box, Flex, Spinner } from '@chakra-ui/react'

import { Colors } from '@/styles/colors'

export const PageLoader = () => {
  return (
    <Flex
      alignItems='center'
      background={Colors.darkBlueGradient}
      h='100vh'
      justifyContent='center'
      w='full'
    >
      <Flex alignItems='center' flexDir='column'>
        <Box mb='8'>
          <Image
            alt='HiveWatch Logo'
            height={71}
            priority
            src='/FullLogo-White.svg'
            width={311}
          />
        </Box>
        <Spinner
          color='white'
          emptyColor='whiteAlpha.400'
          size='xl'
          speed='0.65s'
          thickness='5px'
        />
      </Flex>
    </Flex>
  )
}
